import { ReduxState } from "./redux/state";

export function isSigneringFlow(state: ReduxState): boolean {
  return state.app.params.mode === "signering";
}

export function isBehandlerFlow(state: ReduxState): boolean {
  return state.app.params.mode === "behandler";
}

// Henter ut redirectUrl fra state. Hvis vi ikke kan bygge en returnerer vi false.
// Man må derfor sjekke og agere hvis så er tilfelle
export const callbackUrlIntegrasjon = (state: ReduxState): string | false => {
  const defaultRedirectUrlFromBackend =
    state.org.userInput.selectedIntegrationPartner?.domain;
  const specificRedirectUrlFromState = state.app.params?.redirectUrl;

  if (
    specificRedirectUrlFromState &&
    defaultRedirectUrlFromBackend &&
    specificRedirectUrlFromState.startsWith(defaultRedirectUrlFromBackend)
  ) {
    const address = state.org.digipostaddress
      ? encodeURIComponent(state.org.digipostaddress)
      : "";
    return `${specificRedirectUrlFromState}?sender-id=${state.org.senderId}&dp-address=${address}&nonce=${state.app.params.nonce}&organisation-number=${state.org.organisationNumber}`;
  } else {
    return false;
  }
};
